jQuery(($) => {
    if (!document.body.classList.contains('wp-admin')) return;
    
    const $name = $('.acf-field[data-name="name"] input')
    const $producer = $('.acf-field[data-name="producer"] input')
    const $year = $('.acf-field[data-name="year"] input')

    $name.autocomplete({
        source: function(request, response) {
            $.ajax({
                dataType: 'json',
                url: wp.ajax.settings.url,
                data: {
                    term: request.term,
                    action: 'autocompleteSearch',
                },
                success: function(data) {
                    response(data);
                }
            });
        },
        select: function(event, ui) {
            const { name, producer, year } = ui.item.meta

            setTimeout(() => {
                $name.val(name)
                $producer.val(producer)
                $year.val(year)
            }, 50)
        },
    });
})
